import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShoppingCart, Bell } from 'lucide-react';

export default function AltModal({
  open,
  onClose,
  options,
  currentId,
  mode,
  loading,
  onSelect,
  onToggleWishList,
}) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-4xl max-h-[80vh] flex flex-col gap-0 p-0 overflow-hidden">
        <div className="px-6 pt-5 pb-4 border-b border-gray-100 flex-shrink-0">
          <DialogHeader>
            <DialogTitle className="text-base font-bold text-gray-900">Выберите альтернативу</DialogTitle>
          </DialogHeader>
          <p className="text-xs text-gray-400 mt-1">Сортировка: в наличии → дешевле</p>
        </div>
        <div className="flex-1 overflow-y-auto min-h-0">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
          ) : options.length === 0 ? (
            <p className="text-sm text-gray-500 px-6 py-8 text-center">Нет альтернативных вариантов</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-50 border-b border-gray-200 z-10">
                <tr>
                  <th className="px-4 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide">Наименование</th>
                  <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-28">Бренд</th>
                  <th className="px-3 py-2.5 text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-36">Артикул</th>
                  <th className="px-3 py-2.5 text-center text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-20">Наличие</th>
                  <th className="px-3 py-2.5 text-right text-[10px] font-semibold text-gray-400 uppercase tracking-wide w-28">Цена</th>
                  <th className="px-3 py-2.5 w-32"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {options.map((p) => {
                  const isCurrent = p.id === currentId;
                  const inStock = p.in_stock > 0;
                  return (
                    <tr
                      key={p.id}
                      className={`transition-colors ${
                        isCurrent
                          ? 'bg-indigo-50/60'
                          : inStock
                            ? 'hover:bg-emerald-50/40'
                            : 'opacity-60 hover:bg-gray-50'
                      }`}
                    >
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="font-medium text-gray-900">{p.name}</span>
                          {isCurrent && mode === 'bulk' && (
                            <span className="text-[10px] font-semibold text-indigo-600 bg-indigo-100 px-1.5 py-0.5 rounded-full">
                              Выбран
                            </span>
                          )}
                        </div>
                        {p.category && <div className="text-xs text-gray-400 mt-0.5">{p.category}</div>}
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-600">{p.brand || '—'}</td>
                      <td className="px-3 py-3 font-mono text-xs text-gray-600">{p.articul || p.code || '—'}</td>
                      <td className="px-3 py-3 text-center">
                        {inStock ? (
                          <span className="text-emerald-600 font-bold text-sm">{p.in_stock}</span>
                        ) : (
                          <span className="text-gray-300 text-xs">нет</span>
                        )}
                      </td>
                      <td className="px-3 py-3 text-right">
                        <span className="font-bold text-gray-900">
                          {p.client_price?.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₸
                        </span>
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex items-center justify-end gap-1.5">
                          <button
                            onClick={() => onToggleWishList(p)}
                            title={p.wish_list ? 'Убрать из ожидаемых' : 'Уведомить о наличии'}
                            className={`p-1 rounded transition-colors ${
                              p.wish_list
                                ? 'text-amber-400 hover:text-amber-500'
                                : 'text-gray-300 hover:text-amber-400'
                            }`}
                          >
                            <Bell className="w-4 h-4" />
                          </button>
                          {mode === 'main' ? (
                            <Button
                              size="sm"
                              className="h-7 px-3 text-xs"
                              disabled={!inStock}
                              onClick={() => onSelect(p)}
                            >
                              <ShoppingCart className="w-3 h-3 mr-1" />
                              В корзину
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              variant={isCurrent ? 'outline' : 'default'}
                              className="h-7 px-3 text-xs"
                              onClick={() => onSelect(p)}
                            >
                              {isCurrent ? 'Выбран' : 'Выбрать'}
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
